import React from "react";
import LabelUI from "./LabelUI";

export type ColumnLabelProps = {
  labels: string[];
  color?: string; // Add color prop to support status-specific colors
};

// Define color classes for each status
const colorClasses: {
  [key: string]: { background: string; text: string; ring: string };
} = {
  yellow: {
    background: "bg-yellow-50",
    text: "text-yellow-700",
    ring: "ring-yellow-600/20",
  },
  red: {
    background: "bg-red-50",
    text: "text-red-700",
    ring: "ring-red-600/20",
  },
  green: {
    background: "bg-green-50",
    text: "text-green-700",
    ring: "ring-green-600/20",
  },
  // Fallback for tags or other labels without a specific color
  default: {
    background: "bg-blue-50",
    text: "text-blue-700",
    ring: "ring-blue-600/20",
  },
};

const ColumnLabels: React.FC<ColumnLabelProps> = ({ labels, color }) => {
  return (
    <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
      <div className="flex flex-col">
        {labels?.map((label, index) => {
          // Use the provided color prop for status labels, fallback to default for tags
          const selectedColor = color
            ? colorClasses[color] || colorClasses.default
            : colorClasses.default;

          return (
            <LabelUI
              key={index}
              labelKey={label?.id ? label.id : label}
              background={selectedColor.background}
              text={selectedColor.text}
              ring={selectedColor.ring}
              label={label?.name ? label.name : label}
            />
          );
        })}
      </div>
    </td>
  );
};

export default ColumnLabels;
